// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"fc118a73","488":"4f4e5665","745":"68c747bd"}[chunkId] + ".chunk.js";
};